// Data
const teamData = {
  advisors: [
    { name: "Advisor 1", role: "BOARD ADVISOR", img: "https://cdn.shopify.com/s/files/1/0957/5428/9523/files/WhatsApp_Image_2025-11-17_at_13.15.57.jpg?v=1763365590" },
    { name: "Advisor 2", role: "BOARD ADVISOR", img: "https://cdn.shopify.com/s/files/1/0957/5428/9523/files/WhatsApp_Image_2025-11-17_at_13.15.45.jpg?v=1763365590" },
    { name: "Advisor 3", role: "BOARD ADVISOR", img: "https://cdn.shopify.com/s/files/1/0957/5428/9523/files/WhatsApp_Image_2025-11-17_at_13.15.31.jpg?v=1763365591" },
    { name: "Advisor 4", role: "BOARD ADVISOR", img: "https://cdn.shopify.com/s/files/1/0957/5428/9523/files/WhatsApp_Image_2025-11-17_at_13.15.57.jpg?v=1763365590" },
    { name: "Advisor 5", role: "BOARD ADVISOR", img: "https://cdn.shopify.com/s/files/1/0957/5428/9523/files/WhatsApp_Image_2025-11-17_at_13.15.45.jpg?v=1763365590" },
  ]
};

function loadCards() {
  const container = document.getElementById("teamCards");
  container.innerHTML = "";

  teamData.advisors.forEach(item => {
    container.innerHTML += `
      <div class="swiper-slide">
        <div class="card">
          <img src="${item.img}" alt="${item.name}">
          <div class="card-content">
            <h6>${item.name}</h6>
            <p>${item.role}</p>
          </div>
        </div>
      </div>`;
  });

  swiper.update();
}

// Swiper init
var swiper = new Swiper(".teamSwiper", {
  slidesPerView: 3,
  spaceBetween: 25,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0: { slidesPerView: 1 },
    768: { slidesPerView: 2 },
    1024: { slidesPerView: 3 }
  }
});

// Load advisors directly
loadCards();

// // Data for each tab
// const teamData = {
//   founders: [
//     {name: "Iftekhar Ahmed", role: "FOUNDER & CEO", img: "https://cdn.shopify.com/s/files/1/0957/5428/9523/files/WhatsApp_Image_2025-11-17_at_13.15.57.jpg?v=1763365590"},
//     {name: "Dr Irfan Khan", role: "GROUP CEO, EBG", img: "https://cdn.shopify.com/s/files/1/0957/5428/9523/files/WhatsApp_Image_2025-11-17_at_13.15.45.jpg?v=1763365590"},
//     {name: "Hari", role: "DIRECTOR, EBG", img: "https://cdn.shopify.com/s/files/1/0957/5428/9523/files/WhatsApp_Image_2025-11-17_at_13.15.31.jpg?v=1763365591"},
//   ],

//   advisors: [
//     {name: "Advisor 1", role: "BOARD ADVISOR", img: "https://cdn.shopify.com/s/files/1/0957/5428/9523/files/WhatsApp_Image_2025-11-17_at_13.15.57.jpg?v=1763365590"},
//     {name: "Advisor 2", role: "BOARD ADVISOR", img: "https://cdn.shopify.com/s/files/1/0957/5428/9523/files/WhatsApp_Image_2025-11-17_at_13.15.45.jpg?v=1763365590"},
//     {name: "Advisor 3", role: "BOARD ADVISOR", img: "https://cdn.shopify.com/s/files/1/0957/5428/9523/files/WhatsApp_Image_2025-11-17_at_13.15.31.jpg?v=1763365591"},
//     {name: "Advisor 4", role: "BOARD ADVISOR", img: "https://cdn.shopify.com/s/files/1/0957/5428/9523/files/WhatsApp_Image_2025-11-17_at_13.15.57.jpg?v=1763365590"},
//     {name: "Advisor 5", role: "BOARD ADVISOR", img: "https://cdn.shopify.com/s/files/1/0957/5428/9523/files/WhatsApp_Image_2025-11-17_at_13.15.45.jpg?v=1763365590"},
//   ],

//   consultants: [
//     {name: "Consultant 1", role: "CONSULTANT", img: "https://cdn.shopify.com/s/files/1/0957/5428/9523/files/WhatsApp_Image_2025-11-17_at_13.15.57.jpg?v=1763365590"},
//     {name: "Consultant 2", role: "CONSULTANT", img: "https://cdn.shopify.com/s/files/1/0957/5428/9523/files/WhatsApp_Image_2025-11-17_at_13.15.45.jpg?v=1763365590"},
//     {name: "Consultant 3", role: "CONSULTANT", img: "https://cdn.shopify.com/s/files/1/0957/5428/9523/files/WhatsApp_Image_2025-11-17_at_13.15.31.jpg?v=1763365591"},
//   ]
// };

// function loadCards(type) {
//   const container = document.getElementById("teamCards");
//   container.innerHTML = "";

//   teamData[type].forEach(item => {
//     container.innerHTML += `
//       <div class="swiper-slide">
//         <div class="card">
//           <img src="${item.img}">
//           <div class="card-content">
//             <h6>${item.name}</h6>
//             <p>${item.role}</p>
//           </div>
//         </div>
//       </div>`;
//   });

//   swiper.update(); 
// }

// // Initialize Swiper
// var swiper = new Swiper(".teamSwiper", {
//   slidesPerView: 3,
//   spaceBetween: 25,
//   pagination: {
//     el: ".swiper-pagination",
//     clickable: true,
//   },
//   breakpoints: {
//     0: { slidesPerView: 1 },
//     768: { slidesPerView: 2 },
//     1024: { slidesPerView: 3 }
//   }
// });

// // Load default
// loadCards("founders");

// // Tab switching
// document.querySelectorAll(".tab-btn").forEach(btn => {
//   btn.addEventListener("click", function () {
//     document.querySelectorAll(".tab-btn").forEach(b => b.classList.remove("active"));
//     this.classList.add("active");
//     loadCards(this.dataset.target);
//   });
// });
// //</script>